//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let subHeaderFontSize = '2rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
	}
	//#endregion

	return {
		outerStyle: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
			};
		},
		subHeader: () => {
			return {
				fontSize: subHeaderFontSize,
			};
		},
		iframeStyle: videoLoading => {
			return {
				width: '100%',
				height: '25rem',
				margin: '1rem 0rem 0rem 0rem',
				display: videoLoading ? 'none' : 'flex',
				padding: `0rem ${minimumMarginX}rem`,
			};
		},
		imageThumbnailClasses: () => {
			let classes = 'pointer-hover';
			return classes;
		},
		imageThumbnailStyle: () => {
			return {
				width: '-webkit-fill-available',
				height: isMobile ? '15rem' : '25rem',
				objectFit: isMobile ? 'cover' : 'contain',
				margin: `1rem ${minimumMarginX}rem 0rem ${minimumMarginX}rem`,
			};
		},
	};
}

export default Styles;
